import React from 'react';
import { FadeIn } from './ui';
import { BatteryWarning, HeartCrack, Zap } from 'lucide-react';
export function Story() {
  return <section className="py-24 px-4 bg-brand-darker relative border-t border-white/5" data-id="element-131">
      <div className="max-w-3xl mx-auto" data-id="element-132">
        {/* SECCIÓN 1: EL GANCHO */}
        <FadeIn data-id="element-133">
          <div className="mb-20" data-id="element-134">
            <BatteryWarning className="w-12 h-12 text-brand-red mb-6 opacity-80" data-id="element-135" />
            <h2 className="font-bebas text-4xl md:text-5xl text-white mb-6" data-id="element-136">
              ¿Alguna vez te has quedado sentado en el carro...
            </h2>
            <p className="text-lg md:text-xl text-zinc-300 leading-relaxed mb-6" data-id="element-137">
              ...mirando al vacío antes de entrar a tu casa, simplemente porque
              no tienes fuerzas para lidiar con el ruido de los niños y las
              responsabilidades del hogar?
            </p>
            <p className="text-lg md:text-xl text-brand-orange font-semibold" data-id="element-138">
              No estás solo. Millones de latinos en USA están "quemando el
              motor" intentando proveer, pero perdiendo su vida en el proceso.
            </p>
          </div>
        </FadeIn>

        {/* SECCIÓN 2: AGITACIÓN DEL DOLOR */}
        <FadeIn delay={0.1} data-id="element-139">
          <div className="mb-20 p-8 md:p-10 bg-brand-card rounded-2xl border border-white/5 shadow-2xl relative overflow-hidden" data-id="element-140">
            <div className="absolute top-0 right-0 w-64 h-64 bg-brand-red/5 rounded-full blur-3xl" data-id="element-141" />
            <HeartCrack className="w-10 h-10 text-brand-red mb-6 relative z-10" data-id="element-142" />
            <h3 className="font-bebas text-3xl md:text-4xl text-white mb-6 relative z-10" data-id="element-143">
              Viniste a este país a progresar, no a envejecer 10 años en solo 2.
            </h3>
            <div className="space-y-6 text-zinc-300 text-lg relative z-10" data-id="element-144">
              <p data-id="element-145">
                Sobrevives a punta de bebidas energéticas, cafés cargados y
                pastillas para dormir de Walmart que solo te dejan más atontado
                al día siguiente.
              </p>
              <p data-id="element-146">
                Tus hijos están creciendo y tú solo los ves a través de una nube
                de cansancio. Te duele la espalda, tu paciencia es mínima y
                sientes que el "Sueño Americano" se está convirtiendo en una{' '}
                <strong className="text-white" data-id="element-147">
                  "Pesadilla de Agotamiento"
                </strong>
                .
              </p>
              <p className="text-brand-red font-semibold italic" data-id="element-148">
                Si sigues así, ¿cuánto tiempo crees que tu cuerpo aguantará
                antes de que algo se rompa?
              </p>
            </div>
          </div>
        </FadeIn>

        {/* SECCIÓN 3: LA REVELACIÓN */}
        <FadeIn delay={0.2} data-id="element-149">
          <div data-id="element-150">
            <Zap className="w-12 h-12 text-brand-gold mb-6" data-id="element-151" />
            <h2 className="font-bebas text-4xl md:text-5xl text-white mb-6" data-id="element-152">
              El problema no es tu edad. Tampoco es que no te esfuerces.
            </h2>
            <div className="space-y-6 text-zinc-300 text-lg" data-id="element-153">
              <p data-id="element-154">
                El problema es que estás operando con un{' '}
                <strong className="text-brand-gold" data-id="element-155">
                  Ritmo Circadiano Destrozado
                </strong>
                . En USA, todo está diseñado para mantenerte alerta y estresado:
                las luces artificiales, el azúcar en la comida y la presión
                financiera.
              </p>
              <div className="p-6 border-l-4 border-brand-orange bg-brand-orange/5 my-8" data-id="element-156">
                <p className="text-white font-medium" data-id="element-157">
                  Descubrí que existe un "Camino Corto". Un conjunto de
                  micro-hábitos de 5 minutos que usan la ciencia del Biohacking
                  para reprogramar tu energía desde la célula.
                </p>
              </div>
              <p data-id="element-158">
                No necesitas máquinas de $5,000. Necesitas saber cuándo tomar
                sol, cómo respirar en tu "break" y cómo usar el cafecito a tu
                favor.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}